export default "__VITE_ASSET__OnVtegt$__"